<template>
  <vxe-modal
    ref="modal"
    v-model="formVisible"
    title="问题预览"
    width="90%"
    height="90%"
    show-zoom
    resize
    @show="handleShow"
  >
    <div class="readonly-summary-table">
      <vxe-grid
        ref="xTable"
        resizable
        :data="modalTableData"
        size="mini"
        :mouse-config="{ area: true }"
        highlight-hover-row
        highlight-current-row
        height="100%"
        :columns="readonlyColumns"
        :cell-style="cellStyleMethod"
        :row-config="{ height: 60 }"
        :show-overflow="true"
        :tooltip-config="{
          showAll: true,
          theme: 'dark'
        }"
        :keyboard-config="{
          isArrow: true,
          isEnter: true,
          isTab: true,
          isClip: true,
          enterToTab: true,
          isEdit: false
        }"
        :scroll-y="{
          mode: 'wheel'
        }"
        :clip-config="{
          copyMethod: copyMethod
        }"
        show-footer
        :footer-method="footerMethod"
        @filter-change="filterChange"
        @checkbox-change="$emit('checkbox-change', $event)"
        @checkbox-all="$emit('checkbox-all', $event)"
        @cell-click="$emit('cell-click', $event)"
      />
    </div>
  </vxe-modal>
</template>

<script>
export default {
  props: {
    // 传入 Summary 实例后，弹窗可直接复用原表格的数据、列配置和只读展示方法
    parentObj: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      formVisible: false,
      modalTableData: [],
      readonlyColumns: []
    }
  },
  methods: {
    /**
     * 打开只读表格。
     * 不传参数时默认使用 parentObj 中原表格的全部数据和列配置；
     * 也可以传入原表格筛选后或勾选后的数据。
     */
    // this.$refs.ReadonlySummaryModalRef.openModal(this.tableData, this.gridColumns)
    openModal(tableData, gridColumns) {
      const sourceData = tableData || this.parentObj?.tableData || []
      const sourceColumns = gridColumns || this.parentObj?.gridColumns || []

      this.modalTableData = sourceData.slice().reverse()
      this.readonlyColumns = this.getReadonlyColumns(sourceColumns)
      this.formVisible = true
    },
    // 兼容项目中其他模态窗常用的 showModal 调用方式
    showModal(tableData, gridColumns) {
      this.openModal(tableData, gridColumns)
    },
    handleShow() {
      if (this.readonlyColumns.length === 0) {
        const sourceData = this.parentObj?.tableData || []
        const sourceColumns = this.parentObj?.gridColumns || []
        this.modalTableData = sourceData.slice()
        this.readonlyColumns = this.getReadonlyColumns(sourceColumns)
      }
      this.$nextTick(() => {
        if (this.$refs.xTable) {
          this.$refs.xTable.recalculate()
          this.$refs.xTable.scrollTo(0, 0)
        }
      })
    },
    getReadonlyColumns(columns) {
      return columns
        .filter(col => {
          return ![
            'fileURL',
            'frontDesigners',
            'frontDesignConfirmationTime',
            'frontDesignCol',
            'backDesigners',
            'backDesignConfirmationTime',
            'backDesignCol',
            'designHistory',
            'sort'
          ].includes(col.field)
        })
        .map(column => {
          const readonlyColumn = { ...column }

          // vxe-table 的列级编辑配置不应进入预览表格
          delete readonlyColumn.editRender

          if (Array.isArray(column.children)) {
            readonlyColumn.children = this.getReadonlyColumns(column.children)
          }

          return readonlyColumn
        })
    },
    cellStyleMethod(params) {
      if (this.parentObj && typeof this.parentObj.tableCellStyle === 'function') {
        return this.parentObj.tableCellStyle(params)
      }
      return null
    },
    copyMethod(params) {
      if (this.parentObj && typeof this.parentObj.copyMethod === 'function') {
        return this.parentObj.copyMethod(params)
      }
      return params.cellValue
    },
    footerMethod(params) {
      if (this.parentObj && typeof this.parentObj.footerMethod === 'function') {
        return this.parentObj.footerMethod(params)
      }
      return []
    },
    filterChange(params) {
      this.$emit('filter-change', params)
    }
  }
}
</script>

<style lang="less" scoped>
.readonly-summary-table {
  height: 100%;
}

/deep/ .vxe-body--row {
  height: 80px !important;
}
</style>
